export class EMail {
  private active: boolean;
  private subject_template: string;
  private body_template: string;
  private recipients: string[];
  observers: Set<() => void> = new Set();

  constructor(
    active: boolean,
    subject_template: string,
    body_template: string,
    recipients: string[],
  ) {
    this.setActive(active);
    this.setSubjectTemplate(subject_template);
    this.setBodyTemplate(body_template);
    this.setRecipients(recipients);
  }

  getActive() {
    return this.active;
  }

  getSubjectTemplate() {
    return this.subject_template;
  }

  getBodyTemplate() {
    return this.body_template;
  }

  getRecipients() {
    return this.recipients;
  }

  setActive(active: boolean) {
    this.active = active;
  }

  setSubjectTemplate(subject_template: string) {
    this.subject_template = subject_template;
  }

  setBodyTemplate(body_template: string) {
    this.body_template = body_template;
  }

  setRecipients(recipients: string[]) {
    this.recipients = recipients;
  }

  toJSON() {
    return {
      active: this.active,
      subject_template: this.subject_template,
      body_template: this.body_template,
      recipients: this.recipients,
    };
  }

  addRecipient(recipient: string) {
    this.recipients.push(recipient);
    this.notifyObservers();
  }

  removeRecipient(toBeRemovedEmail: string) {
    this.recipients = this.recipients.filter(
      (recipientEmail) => recipientEmail !== toBeRemovedEmail,
    );
    this.notifyObservers();
  }

  toggleActive() {
    this.active = !this.active;
    this.notifyObservers();
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
